(function () {
    'use strict';

    angular
        .module('app')
        .factory('WorkflowStepTypesService', WorkflowStepTypesService);

    WorkflowStepTypesService.$inject = [];

    function WorkflowStepTypesService() {
        var service = {
            getStepType: getStepType
        };

        var stepTypes = [
            {
                type: 'Start',
                drawingProperties: {
                    color: 'red',
                    type: 'sentinel'
                },
                text: 'Start',
                properties: {}
            },
            {
                type: 'End',
                drawingProperties: {
                    color: 'red',
                    type: 'sentinel'
                },
                text: 'End',
                properties: {}
            },
            {
                type: 'CreateMerge',
                drawingProperties: {
                    color: 'indigo',
                    type: 'box'
                },
                text: 'Create Merge',
                properties: {}
            },
            {
                type: 'Template',
                drawingProperties: {
                    color: 'green',
                    type: 'box'
                },
                text: 'Add Template',
                properties: {
                    'FileName' : 'documenttemplate/2'
                }
            },
            {
                type: 'Inclusion',
                drawingProperties: {
                    color: 'blue',
                    type: 'box'
                },
                text: 'Add Inclusion',
                properties: {
                    'FileName': 'Image1.jpg',
                    'Placeholder': 'placeholder',
                    'InstanceData': ''
                }
            },
            {
                type: 'MergeToDocx',
                drawingProperties: {
                    color: 'mediumblue',
                    type: 'merge'
                },
                text: 'Merge to Docx',
                properties: {}
            },
            {
                type: 'MergeToPdf',
                drawingProperties: {
                    color: 'darkred',
                    type: 'merge'
                },
                text: 'Merge to Pdf',
                properties: {}
            },
            {
                type: 'CreateEntity',
                drawingProperties: {
                    color: 'grey',
                    type: 'box'
                },
                text: 'Create Entity',
                properties: {
                    'Entity Template Name': 'Invoice',
                    'Response': '',
                    'InstanceData': 'InvoiceId'
                }
            },
            {
                type: 'EntityData',
                drawingProperties: {
                    color: 'darkgrey',
                    type: 'box'
                },
                text: 'Add Entity Data',
                properties: {}
            },
            {
                type: 'AggregateData',
                drawingProperties: {
                    color: 'dimgrey',
                    type: 'box'
                },
                text: 'Aggregate Entity Data',
                properties: {
                    'Entity Field': 'Timesheet Items|Hours',
                    'Instance Data': 'Hours'
                }
            },
            {
                type: 'ClearData',
                drawingProperties: {
                    color: 'black',
                    type: 'box'
                },
                text: 'Clear Workflow Data',
                properties: {}
            },
            {
                type: 'EmbedWorkflow',
                drawingProperties: {
                    color: 'lightslategrey',
                    type: 'box'
                },
                text: 'Embedded Workflow',
                properties: {
                    'Workflow ID': ''
                }
            },
            {
                type: 'AddDocument',
                drawingProperties: {
                    color: 'darkslategrey',
                    type: 'box'
                },
                text: 'Add Document to Entity',
                properties: {
                    'ChilliDocs File Name': '',
                    'ChilliDocs File ID': '',
                    'Instance Data For ChilliDocs ID': 'Added Document ID',
                    'Tags': ''
                }
            },
            {
                type: 'ConcatenateDocuments',
                drawingProperties: {
                    color: 'slategrey',
                    type: 'box'
                },
                text: 'Concatenate Documents',
                properties: {
                    'ChilliDocs First File ID': '',
                    'ChilliDocs Second File ID': '',
                    'Instance Data For ChilliDocs ID': 'Created Document ID',
                    'Tags': ''
                }
            },
            {
                type: 'Question',
                drawingProperties: {
                    color: 'orange',
                    type: 'question'
                },
                text: 'Question',
                properties: {
                    'Question': 'The Question?',
                    'Choices': '1: one|2: two',
                    'Values': 'the 1 value|the 2 value',
                    'Response': '',
                    'InstanceData': ''
                }
            },
            {
                type: 'Branch',
                drawingProperties: {
                    color: 'seagreen',
                    type: 'branch'
                },
                text: 'Branch',
                properties: {
                    'Question' : 'The Question?' ,
                    'Comparison' : 'EQ' ,
                    'Choices': 'docx|pdf',
                    'Response': 'docx',
                    'Response From Entity Data': 'Invoice Items Type',
                    'TestValue': 'docx'
                }
            },
            {
                type: 'XeroInvoice',
                drawingProperties: {
                    color: 'dodgerblue'
                },
                text: 'Xero Invoice',
                properties: {
                    'Invoice Type': 'ACCREC/ACCPAY',
                    'Invoice Status': 'DRAFT',
                    'ContactID': 'Client|Xero ID',
                    'Date': 'Date of Invoice',
                    'Reference': 'Purchase Order',
                    'Item Description': 'Timesheet Items|Description',
                    'Item Quantity': 'Timesheet Items|Hours',
                    'Item Account Code': 'Timesheet Items|Resource Code',
                    'Item Date': 'Timesheet Items|Date',
                    'Instance Data For ID': 'Xero Invoice ID',
                    'Branding Theme': '',
                    'Due Date': ''
                }
            },
            {
                type: 'XeroTimesheet',
                drawingProperties: {
                    color: 'dodgerblue'
                },
                text: 'Xero Timesheet',
                properties: {
                    'Hours': 'Timesheet Items|Hours',
                    'Item Date': 'Timesheet Items|Date',
                    'EmployeeID': 'Timesheet Items|EmployeeID',
                    'Status': 'Draft'
                }
            },
            {
                type: 'GetXeroInvoice',
                drawingProperties: {
                    color: 'dodgerblue'
                },
                text: 'Get Xero Invoice',
                properties: {
                    'Instance Data For Xero ID': 'Xero Invoice ID',
                    'Instance Data For ChilliDocs ID': 'ChilliDocs Invoice ID',
                    'Tags': ''
                }
            },
            {
                type: 'SyncDataFromXero',
                drawingProperties: {
                    color: 'dodgerblue'
                },
                text: 'Sync Data From Xero',
                properties: {
                    'Entity Template ID': '',
                    'Entity Fields For Update': '',
                    'Entity Fields For Match': '',
                    'Xero Entity': '',
                    'Xero Fields For Update': '',
                    'Xero Fields For Match': '',
                    'Xero Filter': '',
                    'Delete Unmatched From ChilliDocs': 'No'
                }
            },
            {
                type: 'ToDropbox',
                drawingProperties: {
                    color: '#0bacff'
                },
                text: 'Document to Dropbox',
                properties: {
                    'Token Entity': '',
                    'File ID': '',
                    'Dropbox Folder': 'Uploads'
                }
            }
        ];

        return service;

        function getStepType(stepType) {
            return _.find(stepTypes, { type: stepType });
        }
    }
})();